import { Component } from '@angular/core';
import { MenuMobileService } from '../menu-category-mobile/menu-mobile.service';
@Component({
  selector: 'icon-hamburguer',
  templateUrl: './icon-hamburguer.component.html',
  styleUrl: './icon-hamburguer.component.scss',
  standalone: false,
})
export class IconHamburguerComponent {
  isActived$ = this.menuService.status();

  constructor(private menuService: MenuMobileService) {}

  toggleStatus() {
    this.menuService.toggleStatus();
  }
}
